import { injectGlobal } from 'emotion';
import emotionNormalize from 'emotion-normalize';

import {
  currentColors,
  draftLightColors,
  draftDarkColors,
} from '@circleci/compass';

// theme.legacy has been depricated need to use compass
// compass does not have desired values need to hardcode
export const outer = {
  colors: {
    green: '#049B4A',
    greenDark: '#048C43',
    greenDarkest: '#00701B',
    blue: '#0078CA',
    blueDark: '#0062B0',
    blueDarkest: '#004A95',
  },
  textStroke: '0.4px',
};

// oxlint-disable-next-line no-unused-expressions
injectGlobal`
  ${emotionNormalize}

  *, *::after, *::before {
    box-sizing: border-box;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    font-smooth: always;
  }
  
  
  html {
    font-family: 'Inter', 'Roboto', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  }

  html, body, #__next, #root {
    width: 100%;
    min-height: 100vh;
    font-synthesis: none;
  }

  #__next, #root {
    display: flex;
    flex-direction: column;
  }

  // set custom css properties for all the colours in our theme
  // these will be changed when the theme is changed
  :root {
    ${currentColors}
    color-scheme: light;
    color: var(--content-primary);
  }

  // Root-level theme application (when ThemeProvider sets data-theme on document.documentElement)
  :root[data-theme='light'] {
    ${draftLightColors}
    color-scheme: light;
  }

  :root[data-theme='dark'] {
    ${draftDarkColors}
    color-scheme: dark;
  }

  // Component-level theme application (when data-theme is applied to arbitrary components)
  [data-theme='light'] {
    ${draftLightColors}
  }

  [data-theme='dark'] {
    ${draftDarkColors}
  }
`;
